/**
 * Vrai dès que l'élément approche de l'écran (400 px d'avance), et le reste.
 *
 * Une grille du Vault monte 60 vignettes d'un coup : sans cette porte, 60 requêtes partent
 * ensemble et le proxy sature (incident du 13-05-2026, la moitié des médias en 502).
 * `loading="lazy"` ne suffit pas (heuristique du navigateur) et une `<video>` n'en a pas.
 * Une fois vu, on ne remet pas la source à zéro : sortir de l'écran ne re-télécharge rien.
 */
import { useEffect, useState, type RefObject } from "react";

export function useVisible(ref: RefObject<Element | null>, actif: boolean = true, marge: string = "400px"): boolean {
  const [visible, setVisible] = useState(!actif);
  useEffect(() => {
    if (!actif || visible) return;
    const el = ref.current;
    if (!el || typeof IntersectionObserver === "undefined") {
      setVisible(true);
      return;
    }
    const obs = new IntersectionObserver(
      (entrees) => {
        if (entrees.some((e) => e.isIntersecting)) {
          setVisible(true);
          obs.disconnect();
        }
      },
      { rootMargin: `${marge} 0px`, threshold: 0.01 },
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [ref, actif, visible, marge]);
  return visible;
}
